export const SENTENCES = [
    'I brush my teeth every day',
    'I always close the window at night',
    'The sun rises in the east',
    'I went to Belarus two years ago',
    'Will you be my friend?',
    'I will tell you the whole story',
    'They are moving to the other city',
    'My mother was cooking at the morning',
    'We have known each other since school years',
    'By the end of the year she had learned to cook',
    'I will have translated the article by noon',
    'We have lived here since 1975',
    'He often came here',
    'I was cooking when the phone rang'
]